import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { FC } from "react";
import { DRAWER_WIDTH } from "../constants/components";
import { AccountCircle } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";

import { useNavigate } from "react-router-dom";
import { AuthService } from "../services/auth.service";

import { Menu, MenuItem } from "@mui/material";

interface PrimaryAppBarProps {
  onMenuClick?: () => void;
}

export const PrimaryAppBar: FC<PrimaryAppBarProps> = ({ onMenuClick }) => {

  const authService = new AuthService();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    handleClose();
    navigate("/");
    authService.logout();
    window.location.reload();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{ bgcolor: "background.default" }}>
        <Toolbar sx={{ mr: 2, marginLeft: { xs: 0, md: DRAWER_WIDTH } }}>
          {onMenuClick && (
            <IconButton
              size="large"
              edge="start"
              aria-label="open navigation menu"
              onClick={onMenuClick}
              color="inherit"
              sx={{ display: { xs: "inline-flex", md: "none" }, mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, color: "primary.900" }}
          >
            <strong>Lower 48 HSE</strong>
          </Typography>
          <div style={{ color: "black" }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
};
